import React, { useState, useEffect } from "react";
import Select from "react-select";
import "./gainloss-lists-screen.scss";
import { inject, observer } from "mobx-react";
import { Types } from "../../../../common/APIConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faPlus } from "@fortawesome/free-solid-svg-icons";
import AddEntity from "./add-entity";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { DateTimeFormatter } from "../../../../common/DateFormatterWithZone";
import GainLossSmartSelect from "../gainloss-smartSelect";

const ListsScreen = inject("GainLossListsScreenStore")(
  observer((props) => {
    const {
      entityTypes,
      entityData,
      getEntityTypes,
      getEntityData,
      selectedJurisdiction,
      selectedEntityType,
      setSelectedJurisdiction,
      setSelectedEntityType,
      setEntityData,
      updateEntity,
      addButtonText,
      exportButtonText,
    } = props.GainLossListsScreenStore;
    const { CommonStore } = props;
    const [jurisdiction, setJurisdiction] = useState();
    const [entityType, setEntityType] = useState();

    const jurisdictionOptions = [
      { value: "Plains - North", label: "Plains - North" },
      { value: "Plains - South", label: "Plains - South" },
    ];

    const [isModalOpen, setIsModalOpen] = useState(false);
    const gridRef = React.useRef();

    const getHeaderName = (item) => {
      switch (item) {
        case "isActive":
          return "Active / Inactive";
        case "entityName":
          return "List Values";
        case "entityType":
          return "Entity Type";
        case "jurisdiction":
          return "Jurisdiction";
        case "listId":
          return "List ID";
        case "createdBy":
          return "Created By";
        case "createdDate":
          return "Created Date";
        case "updatedBy":
          return "Updated By";
        case "updatedDate":
          return "Updated Date";
        default:
          return item;
      }
    };

    const actionCellRenderer = (params) => {
      let eGui = document.createElement("div");

      let editingCells = params.api.getEditingCells();
      // checks if the rowIndex matches in at least one of the editing cells
      let isCurrentRowEditing = editingCells.some((cell) => {
        return cell.rowIndex === params.node.rowIndex;
      });

      if (isCurrentRowEditing) {
        eGui.innerHTML = `
    <button  class="action-button update cellbtnstl"  data-action="update" > update  </button>
    <button  class="action-button cancel cellbtnstl"  data-action="cancel" > cancel </button>
    `;
      } else {
        eGui.innerHTML = `
    <button class="action-button edit cellbtnstl celleditbtnstl"  data-action="edit" "> edit  </button>
    
    `;
      }
      return eGui;
    };

    const gridOptions = {
      autoGroupColumnDef: {
        headerName: "GROUP",
        pinned: "left",
        width: 320,
        tooltipValueGetter: function (params) {
          var count = params.node.allChildrenCount;
          if (count != null) {
            return params.value + " (" + count + ")";
          }
          return params.value;
        },
      },
      frameworkComponents: {
        SmartSelect: GainLossSmartSelect,
        dateTimeFormatter: DateTimeFormatter,
      },
      components: {
        actionCellRenderer: actionCellRenderer,
      },
      editType: "fullRow",
      pagination: false,
      paginationPageSize: 20,
      suppressClickEdit: true,
      rowSelection: "single",
      autoSizeColumns: true,
      floatingFilter: true,
      enableRangeSelection: true,
      multiSortKey: "ctrl",
      rowGroupPanelShow: "always",
      rememberGroupStateWhenNewData: true,
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agAggregationComponent",
            statusPanelParams: {
              aggFuncs: ["avg", "count", "min", "max", "sum"],
            },
          },
        ],
      },
      sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
          },
        ],
        showToolPanel: false,
      },
      defaultColDef: {
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      excelStyles: [],
      onRowEditingStarted: (params) => {
        params.api.refreshCells({
          columns: ["action"],
          rowNodes: [params.node],
          force: true,
        });
      },
      onRowEditingStopped: (params) => {
        params.api.stopEditing(true);
        params.api.refreshCells({
          columns: ["action"],
          rowNodes: [params.node],
          force: true,
        });
      },
    };

    const getColumnDefinitions = () => {
      if (entityData?.length > 0) {
        const columnDefs = Object.keys(entityData[0]).map((item) => ({
          field: item,
          hide: item === "listId" || item === "entityType",
          sortable: true,
          filter: true,
          editable: item === "isActive",
          headerName: getHeaderName(item),
          cellEditor: Types.DROPDOWN,
          cellEditorParams: {
            values: [
              { label: "Active", value: "Active" },
              { label: "Inactive", value: "Inactive" },
            ],
          },
          cellRenderer: item.includes("Date") ? "dateTimeFormatter" : null,
        }));

        columnDefs.splice(0, 0, {
          field: "Action",
          headerName: "Action",
          width: 140,
          cellRenderer: "actionCellRenderer",
          editable: false,
          colId: "action",
          pinned: "left",
          onCellClicked: onCellClicked,
        });
        return columnDefs;
      }
      return null;
    };

    const onCellClicked = (params) => {
      if (
        params.column.colId === "action" &&
        params.event.target.dataset.action
      ) {
        let action = params.event.target.dataset.action;
        if (action === "edit") {
          let cols = params.columnApi
            .getAllGridColumns()
            .filter((col) =>
              typeof col.colDef.editable == "function"
                ? col.colDef.editable(params)
                : col.colDef.editable
            );
          let firstCol = {
            colId: "",
          };
          if (cols) {
            firstCol = cols[0];
          }
          let rowIndex = params.node.rowIndex;
          params.api.ensureColumnVisible(firstCol);
          params.api.setFocusedCell(rowIndex, firstCol);
          params.api.startEditingCell({
            rowIndex: params.node.rowIndex,
            // gets the first columnKey
            colKey: params.colDef.colId,
          });
        }
        if (action === "update") {
          updateEntity(params?.data, CommonStore);
          params.api.stopEditing(true);
        }

        if (action === "cancel") {
          getEntityData(CommonStore);
          params.api.stopEditing(true);
        }
        let cols = params.columnApi.getAllDisplayedColumns();
        const NonPinnedColumn = cols.filter((x) => !x.pinned);
        params.api.ensureColumnVisible(NonPinnedColumn[0]);
      }
    };

    const exportToExcel = () => {
      const parentScreenName = props.path.split("/").pop();
      var today = new Date();
      const formattedDate = moment(today).format("YYYYMMDDhhmmss");
      const currentSheet = parentScreenName;
      let fileNameExcelExport =
        currentSheet + "_Export_All_" + formattedDate + "";

      const visibleColumns =
        gridRef.current.api.gridOptionsWrapper.columnApi.getAllDisplayedColumns();
      const columnsToExport = visibleColumns
        .filter((item) => item.colId !== "action")
        .map((item) => item.colId);
      gridRef.current.api.exportDataAsExcel({
        fileName: fileNameExcelExport,
        sheetName: currentSheet,
        columnKeys: columnsToExport,
      });
    };

    const resetData = () => {
      setSelectedEntityType(null);
      setSelectedJurisdiction(null);
      setEntityData([]);
    };

    useEffect(() => {
      resetData();
      getEntityTypes();
    }, []);

    return (
      <div className="col-md-12 lists-screen-container">
        <div className="container cb-title-container">
          <h3 className="cb-title">{"Gain/Loss - Entity List"}</h3>
        </div>
        <div className="col-md-12 filters-container">
          <div className="list-filter-container">
            <div className="dropdown-label">{"Jurisdiction"}</div>
            <Select
              className="jurisdiction-dropdown dropdown"
              options={jurisdictionOptions}
              value={jurisdiction}
              onChange={(option) => {
                setJurisdiction(option);
                setSelectedJurisdiction(option);
                getEntityData(CommonStore, option, entityType);
              }}
            />
          </div>
          <div className="list-filter-container">
            <div className="dropdown-label">{"Entity type"}</div>
            <Select
              className="entity-type-dropdown dropdown"
              options={entityTypes}
              value={entityType}
              onChange={(option) => {
                setEntityType(option);
                setSelectedEntityType(option);
                getEntityData(CommonStore, jurisdiction, option);
              }}
            />
          </div>
        </div>
        <div className="col-md-12 table-container">
          {entityData?.length > 0 ? (
            <>
              <div
                id={"gainloss-lists"}
                style={{ width: "100%" }}
                className="col-md-12 ag-fresh"
              >
                <div
                  className="ag-theme-balham grid-container"
                  style={{
                    font: ".8em Segoe UI, sans-serif",
                    margin: "15px",
                  }}
                >
                  <AgGridReact
                    ref={gridRef}
                    gridOptions={gridOptions}
                    columnDefs={getColumnDefinitions()}
                    rowData={entityData}
                  ></AgGridReact>
                </div>
              </div>
              <div className="action-toolbar">
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={() => setIsModalOpen(true)}
                >
                  <FontAwesomeIcon icon={faPlus} /> {addButtonText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={exportToExcel}
                >
                  <FontAwesomeIcon icon={faFileExport} /> {exportButtonText}
                </button>
              </div>
              <AddEntity
                isModalOpen={isModalOpen}
                handleModalClose={() => setIsModalOpen(false)}
                {...props}
              />
            </>
          ) : (
            <div className="instruction">
              Please select a Jurisdiction and an Entity type to retrieve data
            </div>
          )}
        </div>
      </div>
    );
  })
);

export default ListsScreen;
